import { images } from './index';

const interiorMeta = [
  { category: 'workspaces', zone: 'Executive Studio', subtitle: 'Linear Acoustic Timber & Diffused Task Lighting' },
  { category: 'living', zone: 'Formal Living Lounge', subtitle: 'Custom Fluted Walnut Wall & Emerald Velvet' },
  { category: 'living', zone: 'Double-Height Atrium', subtitle: 'Architectural Skylight & Floating Cantilever Stair' },
  { category: 'suites', zone: 'Master Suite', subtitle: 'Warm Sconce Layering & Upholstered Accent Headboard' },
  { category: 'workspaces', zone: 'Conference Suite', subtitle: 'Acoustic Wall Paneling & Fluted Glass Partitions' },
  { category: 'foyers', zone: 'Grand Entrance Foyer', subtitle: 'Inlaid Geometric Marble & Custom Millwork' },
  { category: 'suites', zone: 'Canopy Master Suite', subtitle: 'Rose Gold Four-Poster Bed & Crystal Chandelier' },
  { category: 'suites', zone: 'Garden Guest Suite', subtitle: 'Canopy Daybed, Textured Geometric Wall & Plants' },
  { category: 'living', zone: 'Penthouse Velvet Lounge', subtitle: 'Liquid Wood Wave Wall & Crystal Chandelier' },
  { category: 'suites', zone: 'Grand Palace Suite', subtitle: 'Ornate Gold Carvings & Crystal Lighting' },
  { category: 'foyers', zone: 'Grand Banquet Hall', subtitle: 'French Baroque Moldings & Symmetrical Columns' },
  { category: 'living', zone: 'Double-Volume Living Salon', subtitle: 'High-Ceiling Glazing & Sculptural Pendants' },
  { category: 'suites', zone: 'Minimalist Luxury Suite', subtitle: 'Concealed Cove Lighting & Neutral Linen' },
  { category: 'living', zone: 'Contemporary Great Room', subtitle: 'Fluted Wood Paneling & Bookmatched Marble' },
  { category: 'workspaces', zone: 'Design Studio Lab', subtitle: 'Architectural Material Library & Workstation' },
  { category: 'living', zone: 'Family Media Lounge', subtitle: 'Seamless Indoor-Outdoor Connection with Terrace' },
  { category: 'foyers', zone: 'Double-Height Entrance', subtitle: 'Sculptural Pendant Cluster & Fluted Columns' },
  { category: 'suites', zone: 'Executive Master Suite', subtitle: 'Integrated Vanity Joinery & Warm Travertine' },
  { category: 'living', zone: 'Formal Dining Salon', subtitle: 'Bespoke 10-Seater Table & Architectural Lighting' },
  { category: 'foyers', zone: 'Elevator Vestibule', subtitle: 'Charcoal Slats & Backlit Onyx Wall Panel' },
  { category: 'suites', zone: 'Walk-In Dressing Suite', subtitle: 'Smoked Glass Closets & Integrated Island' },
  { category: 'workspaces', zone: 'Creative Team Office', subtitle: 'Open-Plan Collaboration Bench & Material Board' },
  { category: 'living', zone: 'Sunken Courtyard Lounge', subtitle: 'Natural Stone Flooring & Planter Light Wells' },
  { category: 'foyers', zone: 'Grand Staircase Hall', subtitle: 'Curved Plaster Balustrade & Recessed Step Lights' },
  { category: 'suites', zone: 'Serene Minimalist Bedroom', subtitle: 'Limewash Walls & Concealed Storage' },
  { category: 'living', zone: 'Cocktail Bar Lounge', subtitle: 'Backlit Quartzite Counter & Dark Oak Shelving' },
  { category: 'foyers', zone: 'Main Entry Gallery', subtitle: 'Architectural Portal & Sculptural Niche' },
  { category: 'suites', zone: 'Garden Suite Bedroom', subtitle: 'Full-Height Glazing & Sheer Drapery Pocket' },
  { category: 'workspaces', zone: 'Director Cabin', subtitle: 'Leather Desk & Walnut Acoustic Paneling' },
  { category: 'living', zone: 'Media & Entertainment Den', subtitle: 'Acoustic Fabric Baffles & Dimmable Scene Lighting' },
  { category: 'foyers', zone: 'Upper Floor Atrium Bridge', subtitle: 'Frameless Glass Railing & Overhead Skylight' },
  { category: 'living', zone: 'Bespoke Breakfast Lounge', subtitle: 'Fluted Island Counter & Pendant Trio' },
];

const sizePattern = ['wide', 'tall', 'standard', 'standard', 'featured', 'standard', 'tall', 'standard'];

export const interiors = images.interiors.map((image, index) => {
  const id = index + 1;
  const meta = interiorMeta[index] || {
    category: 'living',
    zone: `Interior Space ${String(id).padStart(2, '0')}`,
    subtitle: 'Bespoke Architectural Joinery & Atmospheric Light',
  };

  return {
    id,
    image,
    number: `INT-${String(id).padStart(2, '0')}`,
    size: sizePattern[index % sizePattern.length],
    title: meta.zone,
    subtitle: meta.subtitle,
    category: meta.category,
  };
});

export default interiors;
